import axios from "axios";
import { authApi } from "../backend_urls/authApi";

const BackendBaseURL = process.env.REACT_APP_API_URL

const api = axios.create({ baseURL: BackendBaseURL, withCredentials: true });

// Handlers set from AuthContext
let logoutHandler = null;
let sessionExpiredHandler = null;

export const setLogoutHandler = (handler) => { logoutHandler = handler; };
export const setSessionExpiredHandler = (handler) => { sessionExpiredHandler = handler; };

// 🔹 REQUEST INTERCEPTOR (attach access token)
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) { config.headers.Authorization = `Bearer ${token}`; }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🔹 RESPONSE INTERCEPTOR (handle 401 + refresh token)
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        const isAuthRoute =
            originalRequest.url.includes("/users/auth/login-email/") ||
            originalRequest.url.includes("/users/token/refresh/") ||
            originalRequest.url.includes("/users/token/verify/");

        // Skip interceptor for auth routes
        if (isAuthRoute) {
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const res = await api.post(
                    authApi.userTokenRefresh(),
                    {},
                    { withCredentials: true }
                );

                const newAccessToken = res.data.access;

                // Save new token
                localStorage.setItem("accessToken", newAccessToken);

                // Update header and retry original request
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                return api(originalRequest);

            } catch (refreshError) {
                // If refresh token is expired or invalid -> trigger session expired modal
                if (sessionExpiredHandler) {
                    sessionExpiredHandler();
                } else if (logoutHandler) {
                    logoutHandler();
                }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
